import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils';

type SignedOutNoticeProps = {
    /** `pages` key explaining why the last session on this device ended. */
    messageKey: string;
};

/**
 * Render-only: tells the seller picker why the previous session ended (SEL-23),
 * e.g. the account was signed in on another sale point.
 */
export const SignedOutNotice: React.FC<SignedOutNoticeProps> = ({
    messageKey,
}) => {
    const { t } = useTranslation('pages');

    return (
        <Alert
            {...getNodeTestIdProp('seller-login-signed-out-notice')}
            role="alert"
            status="warning"
        >
            <Alert.Indicator />
            <Alert.Content>
                <Alert.Title>{t(messageKey)}</Alert.Title>
            </Alert.Content>
        </Alert>
    );
};
